$(document).ready(function () {

    var hubActivite = null;
    var hubSituation = null;
    var hubBesoins = null;

    $( "#filter-status" )
        .change(function() {

            if (($('#filter-status').children("option:selected").val() == "gen") || ($('#filter-status').children("option:selected").val() == "retCiv") || ($('#filter-status').children("option:selected").val() == "retMil") || ($('#filter-status').children("option:selected").val() == "pol") || ($('#filter-status').children("option:selected").val() == "res")  || ($('#filter-status').children("option:selected").val() == "pom")  || ($('#filter-status').children("option:selected").val() == "civ"))
            {

                $( "#groupe-situation").hide( "slow" );}


            /*if ($('#filter-status').children("option:selected").val() == "gen")
            {
                $('#lien-filtre').attr('href', '/produits/sante/fortego-gendarme');

            }*/

            else {
                $( "#groupe-situation").show( "slow" );

            }


        })



    function hubMaj() {

        hubActivite = $('#filter-status').children("option:selected").val();
        hubSituation = $('#filter-situation').children("option:selected").val();
        if($('input[name=filter-needs]').length) {
            hubBesoins = $('input[name=filter-needs]:checked');
        }
    }

    function hubValid() {

        hubMaj();

        if (hubBesoins) {

            return hubActivite && hubSituation && hubBesoins.length;
        }

        if ((hubActivite == 'gen') || (hubActivite == 'retCiv') || (hubActivite == 'retMil') || (hubActivite == 'pol')  || (hubActivite == 'pom')  || (hubActivite == 'res') || (hubActivite == 'civ')) {

            hubSituation = 'fra';
            return hubActivite && hubSituation;
        }

        return hubActivite && hubSituation;


        return false;
    }

    function hubAfficheSelection() {

        var selecteur = null;

        if(hubBesoins) {
            $.each($('input[name=filter-needs]:checked'), function () {
                selecteur = "div.app-card-filtered.filtre-" + hubActivite + '-' + hubSituation + '-' + $(this).val();
                $(selecteur).show();
            });
        }
        else {
            selecteur = "div.app-card-filtered.filtre-" + hubActivite + '-' + hubSituation;
            $(selecteur).show("slow");
        }

        // Placement sur ancre nommée pour voir les résultats
        window.location.href = "#offres";
    }

    function hubAfficheMessageAlerte() {
        var dialogBox = $('<div>').attr('class','modal fade').attr('tabindex','-1').attr('role','dialog').attr('aria-hidden','true');
        var message = null;

        if (hubBesoins) {
            message = 'Indiquez d\'abord votre statut, votre situation et votre besoin.';
        }
        else {
            message = 'Indiquez d\'abord votre statut et votre situation.';
        }

        dialogBox.append('<div class="modal-dialog modal-sm">\n' +
            '            <div class="modal-content">\n' +
            '                <div class="modal-header">\n' +
            '                    <p class="modal-title" id="modalDetailTarifLabel">Erreur sur la sélection</p>\n' +
            '                </div>\n' +
            '                <div class="modal-body">\n' +
            '                    <p>' + message + '</p>' +
            '                </div>\n' +
            '                <div class="modal-footer">\n' +
            '                    <button type="button" class="btn btn-primary" data-dismiss="modal">Fermer</button>\n' +
            '                </div>\n' +
            '            </div>\n' +
            '        </div>');

        dialogBox.modal();
    }

    if ($('#hub-selector').length) {



        $("div.app-card-filtered").hide();

        $("button#bt-filtrer").click(function (e) {

            e.stopPropagation();
            e.preventDefault();

            $("div.app-card-filtered").hide();

            if (hubValid()) {
                hubAfficheSelection();
            }
            else{
                hubAfficheMessageAlerte();
            }

        });

        //Si une sélection est déja faite, on déclenche le filtre
        if (hubValid()) {
            $("button#bt-filtrer").trigger("click");
        }

    }

});
